module.exports = __webpack_public_path__ + "img/pistas.989137ab.svg";